import { render, staticRenderFns } from "./DanhSachNhomChucVu.vue?vue&type=template&id=72a52cc0&"
import script from "./DanhSachNhomChucVu.vue?vue&type=script&lang=js&"
export * from "./DanhSachNhomChucVu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports